var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFail = function SvgFail(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 62,
    viewBox: "0 0 60 62",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.932 61.8617C46.4629 61.8617 59.8639 48.241 59.8639 31.439C59.8639 14.637 46.4629 1.01636 29.932 1.01636C13.401 1.01636 0 14.637 0 31.439C0 48.241 13.401 61.8617 29.932 61.8617Z",
    fill: "#DB422B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0342 12.7461L28.4492 36.2812H32.502L32.917 12.7461H28.0342ZM30.5 48.4395C32.4775 48.4395 33.8691 47.0234 33.8691 45.0459C33.8691 43.0439 32.4775 41.6279 30.5 41.6279C28.5225 41.6279 27.1064 43.0439 27.1064 45.0459C27.1064 47.0234 28.5225 48.4395 30.5 48.4395Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/fail.7e25be86.svg";
export { ForwardRef as ReactComponent };